export class AudioAnalyzer {
  private ctx: AudioContext | null = null;
  private analyzer: AnalyserNode | null = null;
  private data: Uint8Array | null = null;

  public connect(audio: HTMLAudioElement) {
    if (!this.ctx) {
      this.ctx = new (
        window.AudioContext ||
        (window as unknown as { webkitAudioContext: typeof AudioContext })
          .webkitAudioContext
      )();
      this.analyzer = this.ctx.createAnalyser();
      this.analyzer.fftSize = 256;
      this.data = new Uint8Array(this.analyzer.frequencyBinCount);
    }
    try {
      const source = this.ctx.createMediaElementSource(audio);
      source.connect(this.analyzer!);
      this.analyzer!.connect(this.ctx.destination);
    } catch (e) {
      console.warn("AudioAnalyzer connect error", e);
    }
  }

  public getAmplitude(): number {
    if (!this.analyzer || !this.data) return 0;
    this.analyzer.getByteTimeDomainData(this.data as unknown as Uint8Array);
    let sum = 0;
    for (const v of this.data) sum += Math.pow((v - 128) / 128, 2);
    return Math.sqrt(sum / this.data.length);
  }
}

export const audioAnalyzer = new AudioAnalyzer();
